import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useFormField } from '../FormField/FormField';

export const Textarea = forwardRef(function Textarea(
  { rows = 4, isInvalid, isDisabled, className, id: idProp, autoResize = false, ...rest },
  ref
) {
  const field = useFormField();
  const id = idProp || field?.id;
  const invalid = isInvalid || field?.invalid;

  const onInput = autoResize ? (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  } : undefined;

  return (
    <textarea
      ref={ref}
      id={id}
      rows={rows}
      disabled={isDisabled}
      onInput={onInput}
      aria-invalid={invalid || undefined}
      aria-describedby={field?.describedBy}
      className={cn(
        'w-full bg-surface text-text placeholder:text-mute-2 outline-none',
        'border border-border rounded-md transition-colors duration-fast px-3 py-2',
        'text-sm leading-relaxed resize-y min-h-[80px]',
        'focus:bg-surface focus:border-ink focus:ring-2 focus:ring-ink/15',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-bg-2',
        invalid && 'border-danger focus:border-danger focus:ring-danger/20',
        autoResize && 'resize-none overflow-hidden',
        className,
      )}
      {...rest}
    />
  );
});

export default Textarea;
